import type { CustomIconProps } from '../CustomIcon';

export const WarningIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  size = 24,
  solid,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M10.7908 3.85923L2.32075 17.9992C2.14612 18.3017 2.05372 18.6445 2.05274 18.9937C2.05176 19.343 2.14224 19.6864 2.31518 19.9898C2.48812 20.2931 2.73748 20.546 3.03846 20.7231C3.33944 20.9002 3.68155 20.9954 4.03075 20.9992H20.9708C21.32 20.9954 21.6621 20.9002 21.963 20.7231C22.264 20.546 22.5134 20.2931 22.6863 19.9898C22.8593 19.6864 22.9497 19.343 22.9488 18.9937C22.9478 18.6445 22.8554 18.3017 22.6808 17.9992L14.2108 3.85923C14.0325 3.56533 13.7815 3.32235 13.4819 3.15371C13.1824 2.98508 12.8445 2.89648 12.5008 2.89648C12.157 2.89648 11.8191 2.98508 11.5196 3.15371C11.22 3.32235 10.969 3.56533 10.7908 3.85923Z'
        fill={color}
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5 9V13'
        stroke={secondaryColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5 17H12.51'
        stroke={secondaryColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
